import "./DynamicFields.css";
import { getText } from "../helpers/supportHelpers";
import { Context } from "../../../../context/Context";
import { useContext } from "react";
import { Input, Select } from "../../../ui";

// Renders a category's configurable form fields. Labels go through the
// shared Input's `label` prop so each one is associated with its control.
const DynamicFields = ({ fields = [], values, onChange }) => {
  const { lang } = useContext(Context);
  const handleChange = (key, value) => {
    onChange({
      ...values,
      [key]: value,
    });
  };

  return (
    <>
      {fields.map((field) => {
        const key = field?.key;
        const label = getText(field?.label, lang);
        const type = field?.type || "text";
        const options = field?.options?.[lang] || [];

        if (!key) return null;

        if (type === "textarea") {
          return (
            <div className="support-form-group full" key={key}>
              <Input
                textarea
                label={label}
                required={field?.required}
                value={values?.[key] || ""}
                onChange={(e) => handleChange(key, e.target.value)}
              />
            </div>
          );
        }

        if (type === "select") {
          const selectOptions = options.map((option) => ({
            value: option,
            label: option,
          }));

          return (
            <div className="support-form-group" key={key}>
              <Select
                label={`${label}${field?.required ? " *" : ""}`}
                value={values?.[key] || ""}
                options={selectOptions}
                placeholder={lang === "ar" ? "اختر" : "Select"}
                onChange={(e) => handleChange(key, e.target.value)}
              />
            </div>
          );
        }

        if (type === "checkbox" || type === "confirm") {
          return (
            <div className="support-form-group full" key={key}>
              <label className="support-checkbox">
                <input
                  type="checkbox"
                  checked={!!values?.[key]}
                  required={field?.required}
                  onChange={(e) => handleChange(key, e.target.checked)}
                />

                <span>
                  {label}
                  {field?.required && " *"}
                </span>
              </label>
            </div>
          );
        }

        return (
          <div className="support-form-group" key={key}>
            <Input
              type={type}
              label={label}
              required={field?.required}
              value={values?.[key] || ""}
              onChange={(e) => handleChange(key, e.target.value)}
            />
          </div>
        );
      })}
    </>
  );
};

export default DynamicFields;
